import React from "react";
import { useT } from "../i18n/LanguageContext";
import { SectionTag } from "../components/Section";
import { Briefcase, Mail, MapPin, ArrowUpRight } from "lucide-react";

const ROLES = [
  { titleK: "careers.role_se", locK: "careers.role_se_loc" },
  { titleK: "careers.role_pm", locK: "careers.role_pm_loc" },
  { titleK: "careers.role_fe", locK: "careers.role_fe_loc" },
  { titleK: "careers.role_sa", locK: "careers.role_sa_loc" },
];

const VALUE_KEYS = ["careers.v1", "careers.v2", "careers.v3", "careers.v4"];

export default function CareersPage() {
  const { t } = useT();
  return (
    <main className="pt-32 md:pt-40" data-testid="page-careers">
      <section className="border-b border-white/10 py-16 md:py-24">
        <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-16">
          <SectionTag>{t("careers.tag")}</SectionTag>
          <h1 className="mt-6 max-w-4xl font-heading text-4xl font-medium tracking-tighter text-white sm:text-5xl lg:text-6xl">
            {t("careers.title")}
          </h1>
          <p className="mt-6 max-w-2xl text-base text-brand-textDim">{t("careers.sub")}</p>
        </div>
      </section>

      {/* Values */}
      <section className="border-b border-white/10 py-20 md:py-28">
        <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-16">
          <p className="font-mono-tag">{t("careers.values_title")}</p>
          <ul className="mt-8 grid gap-px border border-white/10 bg-white/5 sm:grid-cols-2 lg:grid-cols-4">
            {VALUE_KEYS.map((k, i) => (
              <li key={k} className="flex items-start gap-4 bg-brand-bg p-6">
                <span className="font-mono text-[10px] tracking-[0.25em] text-brand-red">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="text-base text-white">{t(k)}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* Open roles */}
      <section className="border-b border-white/10 py-20 md:py-28">
        <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-16">
          <div className="flex flex-wrap items-end justify-between gap-6">
            <div>
              <p className="font-mono-tag">{t("careers.open_title")}</p>
              <h2 className="mt-4 font-heading text-3xl tracking-tight text-white sm:text-4xl">
                {t("careers.open_title")}
              </h2>
            </div>
            <div className="text-sm text-brand-textDim">
              {t("careers.email_note")} {" "}
              <a href="mailto:info@bigradapgroup.com?subject=HR%20—%20Application" className="text-white hover:text-brand-red" data-testid="careers-email">
                info@bigradapgroup.com
              </a>
            </div>
          </div>
          <ul className="mt-10 grid gap-px border border-white/10 bg-white/5">
            {ROLES.map(({ titleK, locK }, i) => (
              <li key={titleK} className="group flex flex-col gap-4 bg-brand-bg p-6 transition-colors hover:bg-[#0E0E0E] md:flex-row md:items-center md:justify-between md:p-8">
                <div className="flex items-start gap-4">
                  <span className="mt-1 font-mono text-[10px] tracking-[0.25em] text-brand-textDim">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <h3 className="font-heading text-xl text-white">{t(titleK)}</h3>
                    <p className="mt-2 flex items-center gap-2 text-sm text-brand-textDim">
                      <MapPin className="h-3.5 w-3.5" />
                      {t(locK)}
                    </p>
                  </div>
                </div>
                <a
                  href={`mailto:info@bigradapgroup.com?subject=HR%20—%20Application%20—%20${encodeURIComponent(t(titleK))}`}
                  data-testid={`careers-apply-${i}`}
                  className="inline-flex w-fit items-center gap-2 border border-white/20 px-4 py-2.5 font-mono text-[10px] uppercase tracking-[0.22em] text-white transition-colors hover:border-brand-red hover:text-brand-red"
                >
                  <Briefcase className="h-3.5 w-3.5" />
                  {t("careers.apply")}
                  <ArrowUpRight className="h-3.5 w-3.5" />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* Email banner */}
      <section className="border-b border-white/10 py-16">
        <div className="mx-auto flex max-w-[1440px] flex-col items-start gap-4 px-6 md:flex-row md:items-center md:justify-between md:px-12 lg:px-16">
          <p className="font-mono-tag">{t("careers.email_note")}</p>
          <a
            href="mailto:info@bigradapgroup.com?subject=HR%20—%20Application"
            className="inline-flex items-center gap-2 bg-brand-red px-6 py-3 font-mono text-[11px] uppercase tracking-[0.22em] text-white hover:bg-brand-redHover"
          >
            <Mail className="h-4 w-4" /> info@bigradapgroup.com
          </a>
        </div>
      </section>
    </main>
  );
}
